module.exports = {
  title: 'Weekly Bar Chart with Reanimated',
  author: 'Enzo Manuel Mangano',
  date: '2024-08-06',
  slug: 'miles-bar-chart',
  tags: ['reanimated'],
};
